import { GetEmailWhitelist } from 'domain/usecases/email-whitelist';
import { HttpClient } from 'data/protocols/http';
import { makeApiUrl } from 'main/factories/http';

export class RemoteGetEmailWhitelist implements GetEmailWhitelist {
  constructor(private readonly httpClient: HttpClient) {}

  async get(params: GetEmailWhitelist.Params): Promise<GetEmailWhitelist.Model> {
    const requestUrl = makeApiUrl(`/emails/locations/${params.locationId}/whitelist`);

    const response = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    return response.body;
  }
}
